import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCreateCollectionKey, getCollectionsKey } from '../../utils/keys';
export const useCreateCollection = (options) => {
    const { useMutationOptions, fields } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const createCollectionKey = getCreateCollectionKey();
    const collectionsKey = getCollectionsKey({});
    return useMutation((input) => client.collections.create(input, fields), {
        mutationKey: createCollectionKey,
        onSuccess: async (_) => {
            queryClient.invalidateQueries(collectionsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useCreateCollection.js.map